import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['submit']

  enableSubmit() {
    this.submitTarget.disabled = false
  }
}
